import { useEffect, useState } from 'react'
import { useCart } from '@chordcommerce/gatsby-theme-autonomy'
import { useCanCount } from '~/hooks/components/use-can-count'

export function useShippingMeter() {
  const cansThreshold = process.env.GATSBY_FREE_SHIPPING_CANS_THRESHOLD || 12
  const weightThreshold =
    process.env.GATSBY_FREE_SHIPPING_WEIGHT_THRESHOLD || 100

  const canCount = useCanCount()
  const { cart } = useCart()

  const [cansNeeded, setCansNeeded] = useState(cansThreshold)

  useEffect(() => {
    const cartWeight = getCartWeight(cart)

    // The OMS actually determines free shipping by weight. In some instances,
    // such as a gift pack that contains 6 cans and heavy, non-wine objects, the
    // weight of a 6-pack will exceed the free shipping threshold. We're ok with
    // giving free shipping in that situation, so rather than tweaking the OMS
    // behavior, we'll ensure the cart's progress meter matches it.
    if (cartWeight >= weightThreshold) {
      setCansNeeded(0)
    }
    // Round a negative difference, which indicates the cart total is larger
    // than the threshold, to zero.
    else {
      setCansNeeded(Math.max(0, cansThreshold - canCount))
    }
  }, [canCount, cansThreshold, weightThreshold]) // eslint-disable-line

  const getCartWeight = (cart) =>
    cart?.lineItems?.reduce(
      (total, lineItem) =>
        total + parseFloat(lineItem.variant.weight) * lineItem.quantity,
      0
    )

  return {
    cansNeededForFreeShipping: cansNeeded,
    eligibleForFreeShipping: cansNeeded === 0,
    isEmpty: canCount === 0,
    percentage: (1 - cansNeeded / cansThreshold) * 100,
  }
}
